module.exports = __webpack_public_path__ + "img/default-cover-video.d20448e5.jpg";